<template>
  <router-link :to="'/work/' + id" class="work-entry">
    <div class="work-thumb"
         :style="thumb ? {'background-image': 'url(' + thumbUrl + ')'} : null"></div>

    <p>{{title}}</p>
  </router-link>
</template>
<script>
export default {
  name: 'workListEntry',
  props: [
    'id', 'title', 'thumb'
  ],
  computed: {
    thumbUrl () {
      return this.thumb.fields.file.url + '?fm=jpg&q=75&fit=fill&w=' + Math.round(window.devicePixelRatio * 350) + '&h=' + Math.round(window.devicePixelRatio * 328)
    }
  }
}
</script>
<!-- Add "scoped" attribute to limit CSS to this component only -->
<style scoped>
  .work-entry {
    width: 360px;
    height: 360px;
    margin: 9px 9px;
    display: flex;
    flex-direction: column;
    text-decoration: none;
    outline: 0 solid #CCC;
    transition: all 0.5s, background 0.2s, outline 0.3s;
  }

  .work-entry:hover{
    outline: 5px solid #CCC;
    background: #CCC;
  }

  .work-entry:hover p{
    color:#222;
  }

  .work-entry p {
    text-align:right;
    color:#FFF;
    font-family:'Roboto Slab';
    font-weight:300;
    margin:4px 2px;
    transition: color 0.2s;
  }
  .work-thumb{
    width:100%;
    background: #CCC;
    background-repeat:no-repeat;
    background-size:cover;
    background-position:center;
    flex:auto;
  }
</style>



// WEBPACK FOOTER //
// src/components/WorkListEntry.vue